<template>
  <div class="story-container">
      <!-- 新增灰色小字 -->
  <div class="story-header-text">
    <p>contact_wx: x66129912</p>
  </div>
  <!-- 新增进度条 -->
  <div v-if="isLoading" class="progress-bar">
      <div class="progress" :style="{ width: progress + '%' }"></div>
    </div>
    <h1 class="page-title">每个人都有属于自己的故事</h1>
    <form @submit.prevent="generateStory" class="story-form">
      <div class="form-group">
        <label for="protagonistName">主角名字：</label>
        <input v-model="storyData.protagonist_name" id="protagonistName" placeholder="请输入主角名字(选填)" />
      </div>
      <div class="form-group">
        <label for="moodTone">情绪基调：</label>
        <input v-model="storyData.mood_tone" id="moodTone" placeholder="请输入全文情绪基调(选填)" />
      </div>
      <div class="form-group">
        <label for="worldSetting">世界观设定：</label>
        <input v-model="storyData.world_setting" id="worldSetting" placeholder="请输入世界观设定(选填)" />
      </div>
      <div class="form-group">
        <label for="otherRequirements">其他剧情要求：</label>
        <input v-model="storyData.other_requirements" id="otherRequirements" placeholder="请输入其他要求(选填，全轮次有效)" />
      </div>
      <!-- 新增全局错误提示 -->
      <div v-if="showDangerAlert" class="danger-alert">
        ⚠️ 输入包含不允许的内容（如HTML标签或脚本）
      </div>

      <!-- <button type="submit">开始你的故事</button> -->
      <button type="submit" :disabled="isLoading">
        {{ isLoading ? '生成中...' : '开始你的故事' }}
      </button>
    </form>
  </div>
</template>

<script>
import { generateStoryStart } from '../api/story';
import DOMPurify from 'dompurify';

export default {
  data() {
    return {
      isLoading: false,
      progress: 0,
      storyData: {
        protagonist_name: '',
        mood_tone: '',
        world_setting: '',
        other_requirements: '',
      },
      showDangerAlert: false
    };
  },
  methods: {
      // 新增输入过滤方法
    sanitizeInput(input) {
      return DOMPurify.sanitize(input, {
        ALLOWED_TAGS: [],       // 禁止所有 HTML 标签
        ALLOWED_ATTR: [],       // 禁止所有属性
        KEEP_CONTENT: true      // 保留文本内容
      });
    },

    // 新增危险内容检测
    hasDangerousContent(input) {
      const forbiddenPattern = /<(script|iframe|style|img)|javascript:|onerror=|onload=|sql\s+insert|drop\s+table/gi;
      return forbiddenPattern.test(input);
    },

    async generateStory() {
      if (this.isLoading) return; 
      try {
      // +++ 新增：在提交前清洗所有输入字段 +++
      const sanitizedData = {};
      for (const [key, value] of Object.entries(this.storyData)) {
        // 清洗每个字段
        const cleanedValue = this.sanitizeInput(value);
        
        // 检查是否包含危险内容
        if (this.hasDangerousContent(cleanedValue)) {
          this.showDangerAlert = true; // 显示提示
          setTimeout(() => this.showDangerAlert = false, 3000); // 3秒后自动隐藏
          return;
        }
        
        sanitizedData[key] = cleanedValue;
      }

      this.isLoading = true;
      this.progress = 10; // 初始进度
      // 创建模拟进度更新
      const progressInterval = setInterval(() => {
        this.progress = Math.min(this.progress + 15, 85); // 渐进加载效果
      }, 800);
      // 使用清洗后的数据发送请求
      const response = await generateStoryStart(sanitizedData);
      // 请求完成后完成进度
      clearInterval(progressInterval);
      this.progress = 100;
      await new Promise(resolve => setTimeout(resolve, 300)); // 等待进度条完成
      this.$store.dispatch('updateStory', response);
      this.$router.push('/continue');
    } catch (error) {
      console.error('Error generating story:', error);
      }finally {
        this.isLoading = false;
        this.progress = 0;
      }
    },
  },
};
</script>

<style scoped>
/* 新增样式 */
.story-header-text {
  color: #e7e3e3;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}
.story-header-text p {
  margin: 0;
}
/* 新增进度条样式 */
.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: rgba(108, 92, 231, 0.1);
  z-index: 9999;
  overflow: hidden;
}
.progress {
  height: 100%;
  background: linear-gradient(90deg, #6c5ce7 0%, #8476f1 100%);
  transition: width 0.3s ease, opacity 0.3s ease;
}
/* 优化按钮禁用状态 */
button:disabled {
  background-color: #b4b4b4;
  cursor: not-allowed;
  transform: none;
}
/* 新增加载动画 */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
button:disabled::after {
  content: "";
  animation: pulse 1.5s infinite;
}

.story-container {
  max-width: 760px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.page-title {
font-size: 1.5rem !important;
color: #2d3436; /* 更柔和的文字颜色，深灰色 */
font-weight: 600; /* 适当增加粗细，增强可读性 */
line-height: 1.5; /* 增加行高，让文本更舒适 */
margin-bottom: 2rem;
text-align: left;
border-left: 4px solid #6c5ce7; /* 保持原有的主题颜色 */
padding-left: 1.2rem; /* 稍微增加内边距，调整视觉效果 */
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* 使用现代字体 */
}


.story-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 0.9rem;
  font-weight: 400;
}

input {
  padding: 0.8rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.25s ease;
  background: white;
  /* transition: transform 0.2s ease; */
}

input::placeholder {
  color: #bbb;
}

input:focus {
  border-color: #6c5ce7;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.1);
  /* transform: scale(1.02); */
}

button {
  background-color: #6c5ce7;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

button:hover {
  background-color: #5a47d2;
}

button:active {
  transform: scale(0.98);
}

/* 增强表单的可用性 */
input:focus,
button:focus {
  outline: none;
}

@media (max-width: 768px) {
  .story-container {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .story-form {
    gap: 1rem;
  }

  input {
    font-size: 0.95rem;
  }

  button {
    padding: 0.8rem 1.6rem;
    font-size: 1rem;
  }
    /* 渐变动效 */
  button {
    background: linear-gradient(135deg, #6c5ce7 0%, #8476f1 100%);
    transition: filter 0.3s;
  }

  button:hover {
    filter: brightness(1.1);
  }

  /* 3D效果 */
  .story-container {
    transform: perspective(1000px);
    box-shadow: 0 20px 50px -10px rgba(108, 92, 231, 0.3);
  }
}

.danger-alert {
  padding: 0.8rem;
  background: #ffe3e3;
  border: 1px solid #ff8787;
  border-radius: 6px;
  color: #ff5252;
  font-size: 0.9rem;
  margin-top: 1rem;
  animation: shake 0.4s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}
</style>
